import * as React from "react";
import { Panel } from "components/bootstrap";
import styles from "./FilterPreview.css";
const FilterPreviewResults = ({ children = void 0, hasError = false }) => /* @__PURE__ */ React.createElement(Panel, { className: styles.filterPreview, bsStyle: hasError ? "danger" : "default" }, /* @__PURE__ */ React.createElement(Panel.Heading, null, /* @__PURE__ */ React.createElement(Panel.Title, null, "Filter Preview")), /* @__PURE__ */ React.createElement(Panel.Body, null, children));
export default FilterPreviewResults;
